// NOTE: react-svg-worldmap@1.1.0 has an invalid `module` field pointing to a non-existent file.
// Vite prefers `module`, so we deep-import the actual built entry to avoid resolution failure.
import { WorldMap } from 'react-svg-worldmap/dist/index.js';
import './VisitorsWorldMap.css';

/**
 * Wrapper around react-svg-worldmap.
 *
 * Expects data in the form: [{ country: 'us', value: 123 }, ...]
 * where `country` is ISO2 (lowercase) to match legacy vectorMap usage.
 */
export const VisitorsWorldMap = ({ data = [] }) => {
  if (!Array.isArray(data) || data.length === 0) {
    return null;
  }

  return (
    <div className="visitors-world-map">
      <WorldMap
        data={data}
        size="responsive"
        color="#006491"
        backgroundColor="#84919B"
        tooltipTextColor="#1E212B"
      />
    </div>
  );
};

export default VisitorsWorldMap;


